/* eslint-disable curly */
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import i18next from "i18next";
import { LanguageType } from "types/localization";
import { setLocalStorageItem } from "utils/localStorage";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";

const isIso = (v?: string | null): v is string =>
  !!v && /^[a-z]{2,3}$/i.test(v);

interface ILocalizationStore {
  language: string | null;
  languages: LanguageType[];
  changeLanguage: (lang: string) => void;
  setLanguages: (langs: LanguageType[]) => void;
}

export const useLocalizationStore = createWithEqualityFn<ILocalizationStore>()(
  devtools(
    persist(
      (set, get) => ({
        language: null,
        languages: [],

        changeLanguage: (lang: string) => {
          const next = (lang || "en").toLowerCase();
          const curr = (get().language || "").toLowerCase();

          if (curr === next) return;

          // Запоминаем предыдущее корректное ISO для rollback
          if (isIso(curr)) {
            setLocalStorageItem("lang_prev", curr);
          }

          i18next.changeLanguage(next);
          set({ language: next });
          setLocalStorageItem(STORAGE_LANGUAGE_NAME, next);
        },

        setLanguages: (langs) => set({ languages: langs }),
      }),
      {
        name: "localization-storage",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ language: state.language }),
      },
    ),
    { name: "Localization Store" },
  ),
  shallow,
);
